export enum OrderTransferStatus {
    TransferringOverFTP,
    Transferring,
    Completed,
    Aborted
}
